import { useTranslation } from "react-i18next";
import { Chip, Grid, Link, Typography } from "@mui/material";
import { useStyle } from "@features/ManageSim/css/eSimActivationModalStyle";
import { CopyTextField } from "@common/CopyTextField/CopyTextField";
import { IServiceWithESimToActivate } from "@features/ManageSim/interface/IServiceWithESimToActivate";
import { IServiceOption, SimpleSelectYourNumber } from "@common/SelectYourNumber/SimpleSelectYourNumber";
import { useState } from "react";
import { Modal } from "@common/Modal/Modal";

interface IParams {
    serviceWithESimToActivateList: IServiceWithESimToActivate[];
    isModalOpen: boolean;
    onClose(): void;
}

export const ESimActivationModal = (props: IParams) => {
    const { serviceWithESimToActivateList, isModalOpen, onClose } = props;
    const { t } = useTranslation(["sim", "common"]);

    const { classes } = useStyle();

    const [selectedService, setSelectedService] = useState<IServiceWithESimToActivate["serviceId"]>(
        serviceWithESimToActivateList[0].serviceId
    );

    const mappedServiceOptionList: IServiceOption[] = serviceWithESimToActivateList.map((service) => ({
        id: service.serviceId,
        label: service.phoneNumber,
    }));

    const serviceWithESimToActivate = serviceWithESimToActivateList.find(
        (service) => service.serviceId === selectedService
    ) as IServiceWithESimToActivate;

    return (
        <Modal close={onClose} hideActions isModalOpen={isModalOpen} title={t("sim:activateYourESim")}>
            <Grid alignItems="center" container direction="column" spacing={1}>
                <Grid item style={{ width: "100%" }} xs={12}>
                    <SimpleSelectYourNumber
                        selectedService={selectedService}
                        serviceList={mappedServiceOptionList}
                        setSelectedService={setSelectedService}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Chip className={classes.stepChip} label="1" />
                </Grid>
                <Grid item xs={12}>
                    <Typography align="center" color="primary" variant="normal">
                        {t("sim:scanThisQrCode")}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography align="center" color="secondary" variant="normal">
                        {t("sim:openOnOtherDevice")}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.qrCodeContainer}>
                        <img
                            alt="QR Code"
                            className={classes.qrCodeImage}
                            src={`data:image/${serviceWithESimToActivate.activationQrCodeFormat};base64,${serviceWithESimToActivate.activationQrCode}`}
                        />
                        <Link
                            download="QR Code"
                            href={`data:image/${serviceWithESimToActivate.activationQrCodeFormat};base64,${serviceWithESimToActivate.activationQrCode}`}
                            underline="always"
                        >
                            <Typography align="center" color="primary">
                                {t("common:downloadQrCode")}
                            </Typography>
                        </Link>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Chip className={classes.stepChip} label="2" />
                </Grid>
                <Grid item xs={12}>
                    <Typography align="center" color="primary" variant="normal">
                        {t("sim:copyThisPassCodeBelow")}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography align="center" color="secondary" variant="normal">
                        {t("sim:needItDuringESimInstallation")}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <CopyTextField text={serviceWithESimToActivate.esimPassCode} width={250} />
                </Grid>
                <Grid item xs={12}>
                    <Chip className={classes.stepChip} label="3" />
                </Grid>
                <Grid item xs={12}>
                    <Typography align="center" color="primary" style={{ paddingBottom: 15 }} variant="normal">
                        {t("sim:followTheInstructions")}
                    </Typography>
                </Grid>
            </Grid>
        </Modal>
    );
};
